/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { nodeStatusColors } from '../constants/nodeStatusColors';
import { NodeStatus } from '../pages/ClusterPage/components/NodeStatus';

export const determineNodeStatusColor = (status: NodeStatus): string => {
  return nodeStatusColors[status] || nodeStatusColors.__fallback;
};
